// we use queryKeys.test.ts to ensure uniqueness between the 2 types of query-key

// organization level react-query keys
export enum ReactQueryKeysGlobal {
  handleLogin = "handleLogin",
  isLoggedIn = "isLoggedIn",
  initializeOrganization = "initializeOrganization",
  myAccounts = "myAccounts",
  accounts = "accounts",
  isOrganizationApproved = "isOrganizationApproved",
  regions = "regions",
  myTenants = "myTenants",
  logins = "logins",
  serviceAccounts = "serviceAccounts",
  organization = "organization",
  organizationSettings = "organizationSettings",
  organizationTrialBalance = "organizationTrialBalance",
  loginId = "loginId",
  organizationSSOId = "organizationSSOId",
  engineMetrics = "engineMetrics",
  networkPolicies = "networkPolicies",
  login = "login",
  claims = "claims",
  organizationCredit = "organizationCredit",
  billing_top_engines = "billing_top_engines",
  billing_top_engines_by_date = "billing_top_engines_by_date",
  billing_engines = "billing_engines",
  billing_data = "billing_data",
  billing_daily_avg_gb_consumption = "billing_daily_avg_gb_consumption",
  billing_gb_consumption = "billing_gb_consumption",
  chartCosts = "chartCosts",
  costs = "costs",
  orgAdminPrivileges = "orgAdminPrivileges",
  paymentMethod = "paymentMethod",
  myPaymentMethods = "myPaymentMethods",
  myInvoices = "myInvoices",
  myOverdueInvoices = "myOverdueInvoices",
  invoiceDetails = "invoiceDetails",
  organizationRoles = "organizationRoles",
  orgRolePrincipals = "orgRolePrincipals",
  orgRoleGrantedRoles = "orgRoleGrantedRoles",
  orgRoleGrantedToRoles = "orgRoleGrantedToRoles",
  orgContractDetails = "orgContractDetails",
  orgContractDetailsDetailed = "orgContractDetailsDetailed",
  averageCreditBurn = "averageCreditBurn",
  actualCreditConsumption = "actualCreditConsumption",
}

// account level react-query keys
export enum ReactQueryKeysAccount {
  roleDatabasePrivileges = "roleDatabasePrivileges",
  rolePrivileges = "rolePrivileges",
  databasesNames = "databasesNames",
  workspaceEngines = "workspaceEngines",
  previewScript = "previewScript",
  ensureRunning = "ensureRunning",
  supportAccess = "supportAccess",
  supportAccessShort = "supportAccessShort",
  loadFiles = "loadFiles",
  user = "user",
  users = "users",
  accountAdminRole = "accountAdminRole",
  engineMonitoring = "engineMonitoring",
  queryHistory = "queryHistory",
  filePreview = "filePreview",
  demo_tool_charts_data = "demo_tool_charts_data",
  columns = "columns",
  tableNames = "tableNames",
  viewNames = "viewNames",
  schemaNames = "schemaNames",
  indexes = "indexes",
  currentUser = "currentUser",
  rbacRoles = "rbacRoles",
  rbacRoleNames = "rbacRoleNames",
  demo_query_concurrency_stats = "demo_query_concurrency_stats",
  demo_query_history = "demo_query_history",
  demo_running_queries = "demo_running_queries",
  demo_running_queries_count = "demo_running_queries_count",
  demo_table_stats = "demo_table_stats",
  database_tables = "database_tables",
  database_views = "database_views",
}

// sidebar react-query keys
export enum ReactQueryKeysSidebar {
  schemas = "sidebar_schemas",
  information_schema = "sidebar_information_schema",
  information_schema_table = "sidebar_information_schema_table",
  tables = "sidebar_tables",
  views = "sidebar_views",
  view_columns = "sidebar_view_columns",
  columns = "sidebar_columns",
  external_tables = "sidebar_external_tables",
  external_table_columns = "sidebar_external_table_columns",
  indexes = "sidebar_indexes",
}
